import liveIcon from '@dtvgo/assets/live-icon.png';
import PlayerButton from '../PlayerButton/PlayerButton.js';
import './LiveButton.scss';
import { jsxs, jsx } from 'react/jsx-runtime';
import '../PlayerButton/PlayerButton.scss';

/* External */

function LiveButton(_ref) {
  var isDelayed = _ref.isDelayed,
    goToLive = _ref.goToLive,
    onLiveText = _ref.onLiveText;
  return /*#__PURE__*/jsxs(PlayerButton, {
    className: "dtv-common-c-live-button ".concat(isDelayed ? 'dtv-common-c-live-button--delayed' : ''),
    tooltip: onLiveText,
    onClick: goToLive,
    children: [/*#__PURE__*/jsx("img", {
      className: "dtv-common-c-live-button__icon",
      alt: "Live",
      src: liveIcon
    }), onLiveText]
  });
}
LiveButton.defaultProps = {
  isDelayed: false,
  goToLive: function goToLive() {},
  onLiveText: ''
};

export { LiveButton as default };
//# sourceMappingURL=LiveButton.js.map
